"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./WidgetFrame.css");

function WidgetFrame(props) {
  var className = props.className,
      children = props.children,
      scoped = props.scoped,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "children", "scoped"]);
  var classNames = (0, _classnames["default"])(['stx-widget-frame', {
    'stx-widget-frame--scoped': scoped
  }, className]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, otherProps, {
    className: classNames
  }), children);
}

WidgetFrame.defaults = {};
WidgetFrame.propTypes = {
  /** Optional className for the WidgetFrame component */
  className: _propTypes["default"].string,

  /** Child elements */
  children: _propTypes["default"].node,

  /** Applies a scoped class so that reset styles can be applied */
  scoped: _propTypes["default"].bool
};
var _default = WidgetFrame;
exports["default"] = _default;